import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";

@Component({
  selector: 'fb-product-pre-order-quantity-input',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './product-pre-order-quantity-input.component.html',
  styleUrls: ['./product-pre-order-quantity-input.component.scss']
})
export class ProductPreOrderQuantityInputComponent implements OnChanges {

	@Input() public product: Product = {} as Product;
	@Input() public minOrderQuantity: number = 50;
	@Input() unit: string = 'meters';

	@Input()
	public stockMessage: string = 'in stock!';
	public consumedFabric: number = 1;
	public quantity: number = 50;
	@Output() public quantityChange = new EventEmitter<number>();
	@ViewChild('quantityInputPreOrder') public quantityInputRef!: ElementRef<HTMLInputElement>;

	private clickCount = 0;
	public showMinOrderQuantityMessage: boolean = false;

	ngOnChanges(changes: any): void {
		if(changes['minOrderQuantity']) {
			this.minOrderQuantity = changes['minOrderQuantity'].currentValue;
			this.quantity = this.minOrderQuantity;
			this.quantityChange.emit(this.quantity);
		}
	}

	public increment(): void {
		let incrementUnit: number = this.product.unit === 'METER'? 0.5 : 1;
		this.showMinOrderQuantityMessage = false;
		this.quantity += incrementUnit;
		this._handleClickFocus();
		this.quantityChange.emit(this.quantity);
	}

	public decrement(): void {
		let incrementUnit: number = this.product.unit === 'METER'? 0.5 : 1;
		if (this.quantity > this.minOrderQuantity) {
			this.showMinOrderQuantityMessage = false;
			this.quantity  -= incrementUnit;
			this.quantityChange.emit(this.quantity);
			this._handleClickFocus();
		}
		else {
			this.showMinOrderQuantityMessage = true;
		}
	}

	public onInputChange(event: Event): void {
		let incrementUnit: number = this.product.unit === 'METER'? 0.5 : 1;
		this.showMinOrderQuantityMessage = false;
		const value = +(event.target as HTMLInputElement).value;
		if(value < this.minOrderQuantity) {
			this.quantity =  this.minOrderQuantity;
			this.showMinOrderQuantityMessage = true;
			(event.target as HTMLInputElement).value = this.minOrderQuantity.toString();
		}
		else {
			this.quantity = Math.round(value / incrementUnit) * incrementUnit;
		}
		this.quantityChange.emit(this.quantity);
	}

	private _handleClickFocus(): void {
		this.clickCount++;
		if (this.clickCount >= 5 && this.quantityInputRef) {
			setTimeout(() => {
				this.quantityInputRef.nativeElement.focus();
				this.clickCount = 0;
			}, 0);
		}
	}
}

